export default {
  NONE: 0,
  SAVING: 1,
  SAVED: 2,
  ERROR: 3,
};
